// extracted by mini-css-extract-plugin
export default {"sidebar":"styles_sidebar__2ypDS","open":"styles_open__I6I+L","sidebarOpen":"styles_sidebarOpen__awDYO","backdrop":"styles_backdrop__611R-","cardBody":"styles_cardBody__+8E6V"};